import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-yx_icon_two_up",
  "use": "icon-yx_icon_two_up-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-yx_icon_two_up\"><path d=\"M512 602.496l-338.752 338.752-90.496-90.496L512 421.504l429.248 429.248-90.496 90.496L512 602.496z m0-320L173.248 621.248 82.752 530.752 512 101.504l429.248 429.248-90.496 90.496L512 282.496z\" fill=\"#666666\" p-id=\"9625\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgIcons/svg/yx_icon_two_up.svg
// module id = ATXx
// module chunks = 76